import lang from "@/views/modules/EmailTemplates/language/en";
import tinymce from 'vue-tinymce-text-editor';


export default {
    name: "new-email-template",
   
    components: {
        'tinymce': tinymce,
    },
    data() {
        return {
            loading: true,
            template: {
                'name':'',
                'template_text':'',
            },
            error_message:{},
            process:false,
            lang:[],
        }
    },
    mounted() {
        this.lang = lang;
    },
    methods: {
        SaveTemplate() {
            const self = this;
            self.loading = true;
            axios.post('api/modules/emailtemplates', self.template).then(function (response) {
                self.loading = false;
                self.$router.push('/modules/emailtemplates');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}